import React, { useState } from "react";
import { ReactComponent as ChevronDown } from "../../../resources/icons/chevron-down.svg";
import { ReactComponent as Lock } from "../../../resources/icons/Padlock Square 2.svg";
import { ReactComponent as UserSvg } from "../../../resources/icons/user-single-neutral-male--close-geometric-human-person-single-up-user-male.svg";
import { useAuthenticationContext } from "../../../contexts/UserContext";
import { useAuthHttpClient } from "../../../api/api-hooks/useAuthHttpClient";
import { roles } from "../../../core/const/roles";

function toFriedlyRole(role: string | undefined) {
    if (!role) {
        return "";
    }
    switch (role) {
        case roles.MunicipalAdminRole:
            return "Kommune Admin";
        case roles.CaseWorkerRole:
            return "Kommune Sagsbehandler";
        case roles.SuperAdminRole:
            return "Super Admin";
        default:
            return role;
    }
}

export function User() {
    const [open, setOpen] = useState<boolean>(false);
    const { user } = useAuthenticationContext();
    const { signOut } = useAuthHttpClient();

    function handleLogOut(e: React.MouseEvent<HTMLDivElement>) {
        e.stopPropagation();
        signOut();
    }

    const role = toFriedlyRole(user?.roles[0]);

    return (
        <div
            className={"flex items-center gap-2 text-primary-identity-Blue"}
            onClick={() => setOpen((x) => !x)}
        >
            <UserSvg className={"h-[16px] w-[16px]"} />
            <span className={"text-sx"}>{user?.fullName}</span>
            <ChevronDown
                className={`transition-transform rotate-${open ? "180" : "0"}`}
            />
            {open && (
                <div
                    className={
                        "absolute rounded-x2 min-w-[229px] p-20 bg-system-white border border-secondary-blue-light right-0 top-[48px] gap-20 flex flex-col text-sx"
                    }
                >
                    <p className={"text-center"}>
                        {role ?? "N/A Role"} i<br />
                        {user?.companyName}
                    </p>
                    <hr />
                    <div
                        className={
                            "flex items-center cursor-pointer justify-center"
                        }
                        onClick={(e) => handleLogOut(e)}
                    >
                        <div className={"flex gap-8"}>
                            <Lock />
                            <span>Log ud</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
